/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/react';

import * as React from 'react';

import config from 'js/app/config';
import Imgix from 'js/components/Imgix';
// i18n
import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2, useTheme } from '@coursera/cds-core';

import _t from 'i18n!nls/teams-v2';

const SOCIAL_PROOF_IMAGE = `${config.url.resource_assets}enterprise/testimonial_sabrina_matthews.png`;

const opacityKeyframes = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, 25px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;

function TeamsSocialProofItem() {
  const theme = useTheme();
  const styles = {
    container: css`
      margin-top: ${theme.spacing(16)};
      padding: ${theme.spacing(16)} ${theme.spacing(24)};
      border: 1px solid ${theme.palette.gray[500]};
      border-radius: 4px;
    `,
    opacityZero: css`
      opacity: 0;
    `,
    fadeInSlow: css`
      animation: ${opacityKeyframes} 1s 1s ease-out forwards;
    `,
  };

  return (
    <div css={[styles.container, styles.opacityZero, styles.fadeInSlow]}>
      <Typography2 component="p">
        <FormattedMessage
          message={_t(`{highlightText}
        Coursera not only offers training from very prestigious institutions but also a service
        platform that allows you to do the kind of tracking that you want."`)}
          highlightText={
            <strong>
              {_t(`"We are looking for scale, credibility, and something we didn't have to build in-house.`)}
            </strong>
          }
          tagName="p"
        />
      </Typography2>
      <div css={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <Typography2 component="p" variant="bodySecondary">
            Sabrina Matthews
          </Typography2>
          <Typography2 component="p" variant="bodySecondary" css={{ fontStyle: 'italic' }}>
            {_t('HR Manager')}
          </Typography2>
          <Typography2 component="p" variant="bodySecondary">
            {_t('Global Learning')}
          </Typography2>
          <Typography2 component="p" variant="bodySecondary">
            ZS Associates
          </Typography2>
        </div>
        <Imgix alt="Sabrina Matthews" css={{ borderRadius: '50%', width: 120, height: 120 }} src={SOCIAL_PROOF_IMAGE} />
      </div>
    </div>
  );
}

export default TeamsSocialProofItem;
